<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card :header="'Add Package'">
          <el-form label-width="160px" :model="form" :rules="addPackageRules" ref="exportForm">
            <div v-if="step == 1" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Introduction</h5>
                  <p>
                    We organize our test(s) in the form of packages. So when you add a new package, we give you the opportunity to select the
                    type of test the package will be built around.
                  </p>
                  <p>Packages come in sizes, or rather, number of test administration codes. So when creating a package, but thoughtful of the package size. Ensure it encompasses enough for all those you would like to organize in one package.</p>
                  <p>&nbsp;</p>
                  <el-button @click="next()">Next</el-button>
                </el-col>
              </el-row>
            </div>
            <div v-if="step == 2" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Instrument Selection</h5>
                  <p>Select the instrument the package will be based on.</p>
                  <el-form-item label="Instrument:" prop="instrument">
                    <el-select v-model="form.instrument" placeholder="Select Instrument">
                      <el-option
                        v-for="item in form.instrumentOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <p>&nbsp;</p>
                  <el-button @click="next()" :disabled="form.instrument === ''">Next</el-button>
                </el-col>
              </el-row>
            </div>
            <div v-if="step == 3" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Package Name</h5>
                  <p>Choose a package name which will be easy for you to identify this package block later.</p>
                  <el-form-item label="Package Name:" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                  <p>&nbsp;</p>
                  <el-button @click="next()" :disabled="form.name === ''">Next</el-button>
                </el-col>
              </el-row>
            </div>
            <div v-if="step == 4" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Package Size</h5>
                  <p>Choose a package size which will accommodate your testing needs. Remember; this is a way to group the test-takers together.</p>
                  <el-form-item label="Package Size:" prop="size">
                    <el-input v-model="form.size" type="number"></el-input>
                  </el-form-item>
                  <p>&nbsp;</p>
                  <el-button @click="next()">Next</el-button>
                </el-col>
              </el-row>
            </div>
            <div v-if="step == 5" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Report Selection</h5>
                  <p>Select the default report to be emailed. Note, each of the following reports will be generated, however, on the one selected will be emailed.</p>
                  <el-form-item label="Report Language:" prop="Report">
                    <el-select v-model="form.report" placeholder="Select a Report">
                      <el-option
                        v-for="item in form.reports"
                        :key="item.value"
                        :label="item.pub"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <p>&nbsp;</p>
                  <el-button @click="next()">Next</el-button>
                </el-col>
              </el-row>
            </div>
            <div v-if="step == 6" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Review</h5>
                  <p>Please review the following and create and save or reset to step 1.</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Instrument:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.instrumentNames[form.instrument]}}</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Name:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.name}}</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Size:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.size}}</p>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6" :offset="6">
                  <p>Report:</p>
                </el-col>
                <el-col :span="12">
                  <p>{{form.report}}</p>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <el-button
                    :disabled="commitLoading"
                    @click.once="commitPackage()"
                    type="primary"
                  >Create Package</el-button>
                  <el-button :disabled="commitLoading" @click="step = 1">Go back to [Step 1]</el-button>
                </el-col>
              </el-row>
            </div>
            <div v-if="step == 7" class="step">
              <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                  <h5>Final Summary</h5>
                  <p>
                    Package
                    <router-link :to="'/packages/v/' + finished.packageId">{{form.name}}</router-link>&nbsp;has been created.
                  </p>
                </el-col>
              </el-row>
            </div>

            <el-steps :active="step" align-center>
              <el-step title="Step 1" description="Introduction"></el-step>
              <el-step title="Step 2" description="Instrument Selection"></el-step>
              <el-step title="Step 3" description="Package Name"></el-step>
              <el-step title="Step 4" description="Package Size"></el-step>
              <el-step title="Step 5" description="Report Selection"></el-step>
              <el-step title="Step 6" description="Review"></el-step>
              <el-step title="Step 7" description="Final summary"></el-step>
            </el-steps>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { unserialize } from '../../shared/unserialize.js';
import axios from '../../shared/axios';

export default {
  computed: {
    ...mapGetters('packages', [
      'getPackageList',
      'getPackageUsers',
      'getUserIdsForCurrent',
      'getPackageUsersPage',
      'getPackageUsersPageSize',
      'getPackageNameById',
      'getPackageSettings'
    ]),
    ...mapGetters('auth', ['getCompanyName'])
  },
  watch: {
    step(n) {
      // console.log(n);
      if (n === 3) {
        axios.get('/packages/new/reports/' + this.form.instrument).then(r => {
          // console.log(r);
          const defaultLang = unserialize(
            r.data.reports[0].languages_supported
          );
          // console.log(defaultLang);

          for (const inc in r.data.association) {
            let abbr = undefined;
            let pub = undefined;
            for (const inc2 in r.data.reportNames) {
              if (
                r.data.reportNames[inc2].verbose_name ===
                r.data.association[inc].report_name
              ) {
                abbr = r.data.reportNames[inc2].abbreviated_name;
                pub = r.data.reportNames[inc2].public_name;
              }
            }
            this.form.reports.push({
              label: r.data.association[inc].report_name,
              value: r.data.association[inc].report_name,
              abbr: abbr,
              pub: pub
            });
          }
        });
      }
    }
  },
  data() {
    const checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input the package size'));
      }
      setTimeout(() => {
        let v = parseInt(value, 10);
        if (!Number.isInteger(v)) {
          callback(new Error('Please input digits'));
        } else {
          if (value < 5) {
            callback(new Error('Package size must be greater than 5'));
          } else {
            callback();
          }
        }
      }, 300);
    };
    return {
      commitLoading: false,
      step: 1,
      form: {
        size: 0,
        instrument: '',
        name: '',
        instrumentOptions: [],
        instrumentNames: {},
        languageOptions: [],
        report: '',
        reports: []
      },
      finished: {
        packageId: 0
      },
      addPackageRules: {
        instrument: [
          {
            required: true,
            message: 'Please select an instrument',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: 'Please input a name',
            trigger: 'blur'
          },
          {
            min: 3,
            max: 55,
            message: 'Length should be 3 to 55',
            trigger: 'blur'
          }
        ],
        size: [{ validator: checkNumber, trigger: 'blur' }]
      }
    };
  },
  created() {
    axios
      .get('export/options')
      .then(r => {
        // console.log(r);
        const lang = [];
        const inst = [];

        const leIds = [];
        for (const inc in r.data.options) {
          if (r.data.options[inc].options.instrument_type === 'Single') {
            leIds.push(r.data.options[inc].id);
          }
        }

        // Languages
        for (const i in r.data.languages) {
          lang.push({
            value: r.data.languages[i].lang_abrv,
            label: r.data.languages[i].lang_fullname
          });
        }

        // Instruments
        const enabledTests = [];
        for (const ii in r.data.enabledTests) {
          enabledTests.push(r.data.enabledTests[ii].test_id);
        }
        for (const iii in r.data.tests) {
          if (
            enabledTests.indexOf(r.data.tests[iii].test_id) > -1 &&
            leIds.indexOf(r.data.tests[iii].test_id) > -1
          ) {
            inst.push({
              value: r.data.tests[iii].test_id,
              label: r.data.tests[iii].test_name_eng
            });
            const id = r.data.tests[iii].test_id;
            this.form.instrumentNames[id] = r.data.tests[iii].test_name_eng;
          }
        }

        this.form.languageOptions = lang;
        this.form.instrumentOptions = inst;
      })
      .catch(e => {
        console.log(e);
      });
  },
  methods: {
    ...mapActions('packages', ['fetchPackageList', 'fetchPackageSettings']),
    ...mapActions('tests', ['fetchTests']),
    next() {
      this.step += 1;
    },
    prev() {
      this.step -= 1;
    },
    commitPackage() {
      this.commitLoading = true;
      axios
        .post('/packages/new/', this.form)
        .then(r => {
          // console.log(r);
          this.commitLoading = false;
          this.step = 7;
          this.finished.packageId = r.data.packageId;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style>
.step {
  min-height: 400px;
}
</style>
